import { Action, ActionReducerMap } from '@ngrx/store';

import * as fromLoginEntity from './login-entity/login-entity.reducer';
import * as fromSession from './session/session.reducer';
import type { AuthState } from './auth.state';
import { passwordReducer } from './password/password.reducer';

export const authReducer: ActionReducerMap<AuthState, Action> = {
  loginEntityState: fromLoginEntity.reducer,
  sessionState: fromSession.reducer,
  password: passwordReducer
};
